import React from "react";
import "../../css/ConnectView.css";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import axios from "axios";
import swal from "sweetalert2";
import { validationForEmail } from "../../js/regex";
import Heading from "../../components/Heading";
import "../../css/legacy.css";
import { col1 } from "../../constant/legacyConstant";
import ReactPixel from "react-facebook-pixel";
import { siteMetadata } from "../../../gatsby-config";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
const DarjiLogo = "https://bawamasalacompany.com/assets/images/Elements/S_Bawa_Sardar_Singh_Bhalla.png";

let duration = 400;

export class Legacy extends React.Component {
  constructor(args) {
    super(args);
    this.inputs = ["Name", "Email", "Message", "Phn"];
    this.state = {
      isLoading: true,
      Error: {},
      values: {},
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
  }
  componentDidMount() {
    ReactPixel.init(siteMetadata.facebookId);
    ReactPixel.track("ViewContent", location);
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    this.setState({
      showTrans: true,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0.1,
      },
    });
  }
  handleChangeAndValidation = (key, e) => {
    let { Error } = this.state;
    this.setState({
      values: {
        ...this.state.values,
        [key]: e.target.value.trim(),
      },
    });
    delete Error[key];
  };
  handleSubmit = () => {
    const { values } = this.state;
    let isFlag = false;
    let error = {};
    // eslint-disable-next-line
    this.inputs.map((item) => {
      if (!values[item] && item !== "Message") {
        isFlag = true;
        error[item] = true;
      } else if (item === "Email") {
        error[item] = !validationForEmail(values[item]);
        isFlag = isFlag === true ? true : error[item];
      }
    });
    let params = `username=${values.Name}&
					email=${values.Email}&
					msg=${values.Message}&
					phone=${values.Phn}`;
    if (isFlag) {
      this.setState({
        Error: error,
      });
    } else {
      swal({
        title: "Submitting Request...",
        onOpen: () => {
          swal.showLoading();
        },
      });
      axios
        .post(`https://blackelephantdigital.in/blackele/sunny/api/bmc-api/public/connect?${params}`)
        .then((response) => {
          swal.close();
          swal({
            title: "Successfully Submitted",
            html: "<div style='text-align: center'>Thank you for getting in touch!</div>",
            type: "success",
          });
          return response;
        })
        .catch((e) => {
          swal({
            title: "Warning",
            html: "<div style='text-align: center'>Internal Server error</div>",
            type: "error",
          });
        });
    }
  };
  render() {
    const { location } = this.props;
    const { defaultStyle } = this.state;
    return (
      <ContentPage>
        <Meta
          title={"Bawa Industries Legacy"}
          description={
            "An offshoot of Bawa Masala Company (BMC), estd. 1952, Bawa Industries has a legacy of over seven decades in spice manufacturing and trading."
          }
          location={location}
        />
        <div className="global__wrapper">
          <div className="legacy__wrapper" style={defaultStyle}>
            <Heading title="Bawa Legacy and The Taste of Tradition" />
            <div className="panel__1">
              <div className="row __media">
                <div className="col-md-3 __media__left">
                  <ScrollAnimation delay={0} duration={0} animateIn="zoomIn" offset={250}>
                    <img src={DarjiLogo} alt="S_Bawa_Sardar Singh_Bhalla" className="img img-responsive" />
                    <div className="name">S.Bawa Sardar Singh Bhalla</div>
                    <div className="founder">Founder of Bawa Masala Company</div>
                  </ScrollAnimation>
                </div>
                <div className="col-md-9 __media__body">
                  <ScrollAnimation delay={0} duration={0} animateIn="bounceInRight" offset={250}>
                    Bawa Brand Masale, established over two decades ago, is a renowned name in premium spice products, and an offshoot of the masala giant, Bawa
                    Masala Company (BMC), with a legacy of over nearly seven decades of expertise in spice and spice blends.
                    <br />
                    <br />
                    After starting in 1952, on a humble note, with a small unit having a capacity to produce merely four basic spices, BMC, thanks to the firm
                    commitment to deliver quality, is a leader in the spice industry, and at the forefront of the domestic and international market with an
                    emphasis on premium quality, constant innovation and consistent delivery on timeless recipes and taste.
                    <br />
                    <br />
                    For good reason. Before hitting the shelf at the outlets, each hygienically produced BMC and Bawa Brand Masale product undergoes stringent
                    quality tests and is packed to keep the freshness and wholesomeness intact for the consumer. Our hi-tech production plant and diligent
                    supervision at each stage during the production process ensure the quality that is a hallmark of BMC, and Bawa Brand Masale.
                    <br />
                    <br />
                    Our products offer a vast range of variety, tickling the taste buds of every food lover.
                  </ScrollAnimation>
                </div>
              </div>
            </div>
            <div className="panel__2">
              <Heading title="Infrastructure, expertise and process" size="large" />
              <div className="content">
                <div className="sub__heading">
                  Bawa Industries has international standard infrastructure, well-poised to meet the daily rigours of global demand for premium Indian spices
                </div>
                <div className="row">
                  <ScrollAnimation delay={0} duration={0} animateIn="bounceInLeft" offset={250}>
                    {col1.map((item, i) => {
                      return (
                        <div className="col-sm-12 infographics" key={i}>
                          <div className="info">
                            <div className="info-img">
                              <img src={item.imgSrc} alt={item.text} className="" />
                            </div>
                            <div className="info-text">{item.text}</div>
                          </div>
                        </div>
                      );
                    })}
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentPage>
    );
  }
}

Legacy.propTypes = {
  location: PropTypes.object,
};

export default Legacy;



// WEBPACK FOOTER //
// ./src/pages/legacy/index.js